import { useState } from 'react';
import { useHttp } from '@veda/dashboard-ui';

/**
 * Hook per scaricare file binari (PDF, CSV) via fetch autenticata.
 * Usa lo stesso meccanismo di AttiTab (download: true + blob).
 */
export function useDownload() {
  const { request } = useHttp();
  const [downloading, setDownloading] = useState(false);

  const download = (url, filename) => {
    setDownloading(true);
    request(url, {
      method: 'GET',
      download: true,
      onSuccess: async (response) => {
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(objectUrl);
        setDownloading(false);
      },
      onError: () => setDownloading(false),
    });
  };

  return { download, downloading };
}
